import React, { useState } from 'react';
import Modal from './Modal';
import TagList from './sub/TagList';
// import { set } from 'react-hook-form';


const ConversationTagsSidebar = ({ tags, availableTags, conversationId, onTagAdded, onTagRemoved }) => {

  const API_URL = process.env.REACT_APP_API_URL; // URL de tu API externa para notificar nuevos clientes
  
  // Estado para controlar la etiqueta seleccionada en el formulario
  const [selectedTagId, setSelectedTagId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Estados para el formulario de actualización de información de la conversación
  const [contactName, setContactName] = useState('');
  const [dni, setDni] = useState('');
  
  // Estado para controlar la visibilidad del modal de añadir etiqueta (si decides usar un modal en lugar de un bloque fijo)
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    console.log("Toggle modal");
    setIsModalOpen(!isModalOpen);
  };




  // Función para manejar la actualización de la información de la conversación (contact_name y dni)
  const handleUpdateInfo = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_URL}conversations/update-info`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          conversationId: conversationId,
          contact_name: contactName,
          dni: dni
        }),
      }); 
      if (response.ok) {
        console.log('Información actualizada exitosamente');
        // limpiar los campos del formulario después de actualizar
        setContactName('');
        setDni('');
        // Aquí podrías disparar una función para actualizar la información de la conversación en el estado global o en el componente padre, dependiendo de cómo esté estructurada tu aplicación.
      } else {
        console.error(response);
      }
    } catch (error) {
      console.error('Error de red al intentar actualizar la información:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Funcion para ejecutar despues de eliminar la etiqueta de la conversación, para actualizar el estado de las etiquetas y que se refleje en la UI al instante sin recargar la página.



  //console.log("El conv id =" + conversationId);
  // Manejador del envío del formulario
  const handleSubmit = async (tag) => {
    // e.preventDefault();
    
    // if (!selectedTagId) return;

    //setIsSubmitting(true);
    console.log("Tag seleccionado para añadir:", tag);
    try {
      const response = await fetch(`${API_URL}etiquetar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          conversationId: conversationId,
          tagId: tag.id
        }),
      });

      if (response.ok) {
        // Aquí podrías disparar una función para actualizar la lista de etiquetas ('tags') 
        // y que se refleje en la UI al instante sin recargar la página.
        console.log('Etiqueta añadida exitosamente');
        toggleModal(); // Cerramos el modal después de añadir la etiqueta
        // 1. Buscamos la etiqueta completa en la lista de disponibles
        // Nota: Asegúrate de comparar los tipos correctos (String o Number)
        // const tagAgregada = availableTags.find(
        //   tag => tag.id.toString() === selectedTagId.toString()
        // );
 console.log("Llamando a onTagAdded con 1:", tag);
        // 2. Si la encontramos y la función existe, la ejecutamos
        if (tag && onTagAdded) {
          console.log("Llamando a onTagAdded con:", tag);
          onTagAdded(tag);
        }
        setSelectedTagId(''); // Limpiamos el select
        
      } else {
        console.error('Error al añadir la etiqueta');
      }
    } catch (error) {
      console.error('Error de red al intentar etiquetar:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Una funcion que elimine la etiqueta cuando se de click sobre ella y que envie una petición al backend para eliminar la etiqueta de la conversación, a la ruta /api/desetiquetar con el conversationId y el tagId, similar a la función de agregar etiqueta pero con la ruta diferente y el método DELETE, por ejemplo:
  const handleRemoveTag = async (tagId) => {

    if (!window.confirm("¿Estás seguro de eliminar esta etiqueta?")) return;

    try {
      const response = await fetch(`${API_URL}desetiquetar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          conversationId: conversationId,
          tagId: tagId
        }),
      });

      if (response.ok) {
        console.log('Etiqueta eliminada exitosamente');
        // Actualizar el estado de las etiquetas para reflejar la eliminación en la UI
       if (onTagRemoved) {
            onTagRemoved(tagId); 
        }
        
      } else {
        console.error('Error al eliminar la etiqueta');
      }
    } catch (error) {
      console.error('Error de red al intentar eliminar la etiqueta:', error);
    } finally {
      // Cualquier limpieza que necesites hacer después de intentar eliminar la etiqueta
    }   
  };


  
  return (
    <aside  className='conversation-tag-sidebar' style={sidebarStyles.container}>
      <header style={sidebarStyles.header}>
        <h3 style={sidebarStyles.title}>Etiquetas de la conversación</h3>
      </header>
      
      {/* Mitad superior: Lista de etiquetas actuales */}
      <ul 
        style={sidebarStyles.tagList}
        onClick={ (e) => {
          // Si el click es en el contenedor de la lista (y no en una etiqueta específica), abrimos el modal para añadir etiqueta
          if (e.target === e.currentTarget) {
            toggleModal();
          }
        } }
      

        >
        {tags.map(tag => (
          <li 
          key={tag.id} 
          style={{ ...sidebarStyles.tagItem, backgroundColor: tag.color, color: ['#4b5563', '#374151', '#1f2937', '#111827', '#000000', '#000', 'black'].includes(
                tag.color?.toLowerCase(),
              )
                ? "#fff"
                : "#fff" }}
          onClick={() => handleRemoveTag(tag.id)} // Agregamos el manejador para eliminar la etiqueta al hacer click
          >
            {tag.name}
            {/* Aquí podrías añadir un botón para eliminar la etiqueta */}
          </li>
        ))}
      </ul>







      {/* Anadir un bloque para mostar el formulario de edición de información del nombre (contact_name) y dni (dni) de la conversación */}
      <div style={sidebarStyles.formContainer}>
        <h4 style={sidebarStyles.formTitle}>Actualizar información de la conversación</h4>
        <form onSubmit={handleUpdateInfo} style={sidebarStyles.form}>
          <input
            type="text"
            placeholder="Nuevo nombre de contacto"
            value={contactName}
            onChange={(e) => setContactName(e.target.value)}
            style={sidebarStyles.input}
          />
          <input
            type="text"
            placeholder="Cedula"
            value={dni}
            onChange={(e) => setDni(e.target.value)}
            style={sidebarStyles.input}
          />
          <button
            type="submit"
            style={sidebarStyles.submitButton2}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Actualizando...' : 'Actualizar'}
          </button>
        </form>
      </div>








      


             {/* Modal para añadir etiqueta (si decides usar un modal en lugar de un bloque fijo) */}
     {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={toggleModal}>
          <TagList 
           onTagClick={handleSubmit}
           tags={availableTags} />
        </Modal>
      )}


    </aside>

   




  );
};

const sidebarStyles = {
  container: {
    padding: '20px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxWidth : '350px',
    backgroundColor: '#353434',
    color: '#fff',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  title: {
    margin: 0,
    fontSize: '1.2rem',
  },
  tagList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    flex: 1, // Esto empuja el formulario hacia la parte inferior
    overflowY: 'auto',
  },
  tagItem: {
    backgroundColor: '#e1f5fe',
    color: '#0277bd',
    padding: '8px 12px',
    borderRadius: '16px',
    marginBottom: '10px',
    fontSize: '0.9rem',
    textTransform: 'capitalize',
    display: 'inline-block',
    marginRight: '8px',
    cursor: 'pointer',
  },
  // Nuevos estilos para el formulario
  formContainer: {
    marginTop: '20px',
    paddingTop: '20px',
    borderTop: '1px solid #eee', // Una línea sutil para separar ambas mitades
  },
  formTitle: {
    margin: '0 0 10px 0',
    fontSize: '1.2rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  select: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '0.95rem',
    outline: 'none',
    color: '#333',
  },
  submitButton: {
    padding: '10px',
    backgroundColor: '#25D366', // Un verde estilo WhatsApp
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.2s',
  },
  submitButton2: {
    padding: '10px',
    backgroundColor: '#e02f18', // Un verde estilo WhatsApp
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.2s',
  },
  input: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '0.95rem',
    outline: 'none',
    color: '#333',
  },
};

export default ConversationTagsSidebar;
